<div
  *ngIf="environment.context() !== 'prod'"
  class="env-banner"
  [ngClass]="{ 'env-banner-dev': environment.context() === 'dev', 'env-banner-test': environment.context() === 'test' }"
>
  {{ environment.context() | titlecase }} Environment
</div>
<div *ngIf="environment.needsToUpdate()" class="banner-message showRefreshBanner">
  <div>
    <h3 class="app text-primary font-bold">New Version Available</h3>
    <p>Click Refresh to get the latest version of the app.</p>
  </div>
  <div class="mr-8">
    <lib-button
      [cssType]="'btn-secondary'"
      [type]="'button'"
      [text]="'Refresh'"
      (click)="refreshApp()"
    ></lib-button>
  </div>
</div>